"use strict";
exports.__esModule = true;
exports.APPLICATION_TYPES = exports.PRICE_TYPE = exports.CALCULATION_BASE = exports.CALCULATION_TYPES = exports.SPO_TYPES = void 0;
exports.SPO_TYPES = [
    'EARLY_BOOKING',
    'BONUS',
    'RATE',
    'CHILD',
    'SENIOR',
    'STAY_PAY',
    'GROUP',
    'LONG_STAY',
    'HONEYMOON',
    'HOT_DEAL',
];
exports.CALCULATION_TYPES = ['CUMULATIVE', 'SEPARATE'];
exports.CALCULATION_BASE = ['ACCOMMODATION', 'ENTRY'];
exports.PRICE_TYPE = ['PERCENT', 'NET'];
exports.APPLICATION_TYPES = ['FIRST_DAY', 'LAST_DAY', 'AVERAGE'];
//# sourceMappingURL=spo.constants.js.map